let exclusiveOpenInFlight = false;

export function isExclusiveOpenInFlight(): boolean {
  return exclusiveOpenInFlight;
}

export function setExclusiveOpenInFlight(value: boolean): void {
  exclusiveOpenInFlight = value;
}
